module.exports = __webpack_public_path__ + "img/Z81_04.8632385b.jpg";